import {
    Accordion,
    Box,
    Divider,
    Modal,
    TabItem,
    type TabItems,
    Tabs,
    Typography,
    useMediaQueryContext,
} from "@drone-js/core";
import { type FunctionComponent, useState } from "react";
import { usePropertySelectionViewModelValue } from "../propertySelectionViewModelAtom";

interface Props {
    isOpen: boolean;
    onClose: () => void;
}

const AirbnbImportTab = () => {
    const {
        inputUrlCms: {
            airbnbModalFirstSectionTitle,
            airbnbModalFirstSectionFirstContent,
            modalFirstSectionSecondContent,
            airbnbModalFirstSectionThirdContent,
            modalSecondSectionTitle,
            modalSecondSectionFirstContent,
            modalSecondSectionSecondContent,
            modalThirdSectionTitle,
            modalThirdSectionFirstContent,
            modalFourthSectionTitle,
            modalFourthSectionContent,
            modalFifthSectionTitle,
            modalFifthSectionContent,
        },
    } = usePropertySelectionViewModelValue();

    return (
        <Box>
            <Box pt="12">
                <Accordion
                    actionType="chevron-icon"
                    actionPosition="start-below"
                    contentSummary={airbnbModalFirstSectionTitle}
                    level={3}
                    data-element-name="find-the-url-section"
                    data-source={1}
                >
                    <Typography variant="body-s" textColor="base.subtle">
                        {airbnbModalFirstSectionFirstContent}
                    </Typography>
                    <Typography variant="body-s" textColor="base.subtle">
                        {modalFirstSectionSecondContent}
                    </Typography>
                    <Divider direction="horizontal" color="base.subtle" my="12" />
                    <Typography variant="body-s" textColor="base.subtle">
                        {airbnbModalFirstSectionThirdContent}
                    </Typography>
                </Accordion>
            </Box>
            <Box pt="12">
                <Accordion
                    actionType="chevron-icon"
                    actionPosition="start-below"
                    contentSummary={modalSecondSectionTitle}
                    level={3}
                    data-element-name="type-of-info-section"
                    data-source={1}
                >
                    <Typography variant="body-s" textColor="base.subtle">
                        {modalSecondSectionFirstContent}
                    </Typography>
                    <Divider direction="horizontal" color="base.subtle" my="12" />
                    <Typography variant="body-s" textColor="base.subtle" mt="12">
                        {modalSecondSectionSecondContent}
                    </Typography>
                </Accordion>
            </Box>
            <Box pt="12">
                <Accordion
                    actionType="chevron-icon"
                    actionPosition="start-below"
                    contentSummary={modalThirdSectionTitle}
                    level={3}
                    data-element-name="import-specific-listing-section"
                    data-source={1}
                >
                    <Typography variant="body-s" textColor="base.subtle">
                        {modalThirdSectionFirstContent}
                    </Typography>
                </Accordion>
            </Box>
            <Box pt="12">
                <Accordion
                    actionType="chevron-icon"
                    actionPosition="start-below"
                    contentSummary={modalFourthSectionTitle}
                    level={3}
                    data-element-name="limit-listing-number-section"
                    data-source={1}
                >
                    <Typography variant="body-s" textColor="base.subtle">
                        {modalFourthSectionContent}
                    </Typography>
                </Accordion>
            </Box>
            <Box pt="12">
                <Accordion
                    actionType="chevron-icon"
                    actionPosition="start-below"
                    contentSummary={modalFifthSectionTitle}
                    level={3}
                    data-element-name="type-of-listing-section"
                    data-source={1}
                >
                    <Typography variant="body-s" textColor="base.subtle">
                        {modalFifthSectionContent}
                    </Typography>
                </Accordion>
            </Box>
        </Box>
    );
};

const BookingImportTab = () => {
    const {
        inputUrlCms: {
            bcomModalFirstSectionTitle,
            bcomModalFirstSectionFirstContent,
            bcomModalFirstSectionSecondContent,
            bcomModalFirstSectionThirdContent,
            modalSecondSectionTitle,
            modalSecondSectionFirstContent,
            modalSecondSectionSecondContent,
            bcomModalThirdSectionTitle,
            bcomModalThirdSectionContent,
            bcomModalFourthSectionTitle,
            bcomModalFourthSectionContent,
        },
    } = usePropertySelectionViewModelValue();

    return (
        <Box>
            <Box pt="12">
                <Accordion
                    actionType="chevron-icon"
                    actionPosition="start-below"
                    contentSummary={bcomModalFirstSectionTitle}
                    level={3}
                    data-element-name="find-the-url-section"
                    data-source={2}
                >
                    <Typography variant="body-s" textColor="base.subtle">
                        {bcomModalFirstSectionFirstContent}
                    </Typography>
                    <Typography variant="body-s" textColor="base.subtle">
                        {bcomModalFirstSectionSecondContent}
                    </Typography>
                    <Divider direction="horizontal" color="base.subtle" my="12" />
                    <Typography variant="body-s" textColor="base.subtle">
                        {bcomModalFirstSectionThirdContent}
                    </Typography>
                </Accordion>
            </Box>
            <Box pt="12">
                <Accordion
                    actionType="chevron-icon"
                    actionPosition="start-below"
                    contentSummary={modalSecondSectionTitle}
                    level={3}
                    data-element-name="type-of-info-section"
                    data-source={2}
                >
                    <Typography variant="body-s" textColor="base.subtle">
                        {modalSecondSectionFirstContent}
                    </Typography>
                    <Divider direction="horizontal" color="base.subtle" my="12" />
                    <Typography variant="body-s" textColor="base.subtle" mt="12">
                        {modalSecondSectionSecondContent}
                    </Typography>
                </Accordion>
            </Box>
            <Box pt="12">
                <Accordion
                    actionType="chevron-icon"
                    actionPosition="start-below"
                    contentSummary={bcomModalThirdSectionTitle}
                    level={3}
                    data-element-name="limit-listing-number-section"
                    data-source={2}
                >
                    <Typography variant="body-s" textColor="base.subtle">
                        {bcomModalThirdSectionContent}
                    </Typography>
                </Accordion>
            </Box>
            <Box pt="12">
                <Accordion
                    actionType="chevron-icon"
                    actionPosition="start-below"
                    contentSummary={bcomModalFourthSectionTitle}
                    level={3}
                    data-element-name="type-of-listing-section"
                    data-source={2}
                >
                    <Typography variant="body-s" textColor="base.subtle">
                        {bcomModalFourthSectionContent}
                    </Typography>
                </Accordion>
            </Box>
        </Box>
    );
};

const RakutenImportTab = () => {
    const {
        inputUrlCms: {
            rakutenModalFirstSectionTitle,
            rakutenModalFirstSectionTitleFirstContent,
            rakutenOyadoModalFirstSectionTitleFirstContent,
            rakutenModalFirstSectionTitleSecondContent,
            rakutenModalFirstSectionTitleThirdContent,
            modalSecondSectionTitle,
            rakutenModalSecondSectionFirstContent,
            modalSecondSectionSecondContent,
            modalFourthSectionTitle,
            rakutenModalThirdSectionFirstContent,
            modalFifthSectionTitle,
            rakutenModalFourthSectionFirstContent,
        },
        showRakutenOyadoImport,
    } = usePropertySelectionViewModelValue();

    return (
        <Box>
            <Box pt="12">
                <Accordion
                    actionType="chevron-icon"
                    actionPosition="start-below"
                    contentSummary={rakutenModalFirstSectionTitle}
                    level={3}
                    data-element-name="find-the-url-section"
                    data-source={3}
                >
                    <Typography variant="body-s" textColor="base.subtle">
                        {showRakutenOyadoImport
                            ? rakutenOyadoModalFirstSectionTitleFirstContent
                            : rakutenModalFirstSectionTitleFirstContent}
                    </Typography>
                    <Typography variant="body-s" textColor="base.subtle">
                        {rakutenModalFirstSectionTitleSecondContent}
                    </Typography>
                    <Divider direction="horizontal" color="base.subtle" my="12" />
                    <Typography variant="body-s" textColor="base.subtle">
                        {rakutenModalFirstSectionTitleThirdContent}
                    </Typography>
                </Accordion>
            </Box>
            <Box pt="12">
                <Accordion
                    actionType="chevron-icon"
                    actionPosition="start-below"
                    contentSummary={modalSecondSectionTitle}
                    level={3}
                    data-element-name="type-of-info-section"
                    data-source={3}
                >
                    <Typography variant="body-s" textColor="base.subtle">
                        {rakutenModalSecondSectionFirstContent}
                    </Typography>
                    <Divider direction="horizontal" color="base.subtle" my="12" />
                    <Typography variant="body-s" textColor="base.subtle" mt="12">
                        {modalSecondSectionSecondContent}
                    </Typography>
                </Accordion>
            </Box>
            <Box pt="12">
                <Accordion
                    actionType="chevron-icon"
                    actionPosition="start-below"
                    contentSummary={modalFourthSectionTitle}
                    level={3}
                    data-element-name="limit-listing-number-section"
                    data-source={3}
                >
                    <Typography variant="body-s" textColor="base.subtle">
                        {rakutenModalThirdSectionFirstContent}
                    </Typography>
                </Accordion>
            </Box>
            <Box pt="12">
                <Accordion
                    actionType="chevron-icon"
                    actionPosition="start-below"
                    contentSummary={modalFifthSectionTitle}
                    level={3}
                    data-element-name="type-of-listing-section"
                    data-source={3}
                >
                    <Typography variant="body-s" textColor="base.subtle">
                        {rakutenModalFourthSectionFirstContent}
                    </Typography>
                </Accordion>
            </Box>
        </Box>
    );
};

export const LearnMoreModal: FunctionComponent<Props> = ({ isOpen, onClose }) => {
    const {
        inputUrlCms: { learnMore, bcomModalTab, airbnbModalTab, rakutenModalTab },
        showRakutenImport,
    } = usePropertySelectionViewModelValue();

    const context = useMediaQueryContext();
    const [activeTab, setActiveTab] = useState(0);
    const onTabChange = (index) => setActiveTab(index);

    const tabItems: TabItems = showRakutenImport
        ? [
              <TabItem
                  key="rakuten-modal-tab"
                  label={rakutenModalTab}
                  data-element-name="import-tab"
                  data-source={3}
              />,
              <TabItem key="airbnb-modal-tab" label={airbnbModalTab} data-element-name="import-tab" data-source={1} />,
              <TabItem key="bcom-modal-tab" label={bcomModalTab} data-element-name="import-tab" data-source={2} />,
          ]
        : [
              <TabItem key="airbnb-modal-tab" label={airbnbModalTab} data-element-name="import-tab" data-source={1} />,
              <TabItem key="bcom-modal-tab" label={bcomModalTab} data-element-name="import-tab" data-source={2} />,
          ];

    const activeTabContent = showRakutenImport ? (
        activeTab === 0 ? (
            <RakutenImportTab />
        ) : activeTab === 1 ? (
            <AirbnbImportTab />
        ) : (
            <BookingImportTab />
        )
    ) : activeTab === 0 ? (
        <AirbnbImportTab />
    ) : (
        <BookingImportTab />
    );

    return (
        <>
            <Modal visible={isOpen} onClose={onClose} size={context.m ? "m" : "s"} zIndex={1060} title={learnMore}>
                <Tabs
                    width="content-fit"
                    id="learn-more-tabs"
                    label="learn-more-tabs"
                    nextTabsLabel="Next tab"
                    previousTabsLabel="Previous tab"
                    items={tabItems}
                    onTabChange={onTabChange}
                >
                    {activeTabContent}
                </Tabs>
            </Modal>
        </>
    );
};
